// REMIX HMR BEGIN
if (!window.$RefreshReg$ || !window.$RefreshSig$ || !window.$RefreshRuntime$) {
  console.warn('remix:hmr: React Fast Refresh only works when the Remix compiler is running in development mode.');
} else {
  var prevRefreshReg = window.$RefreshReg$;
  var prevRefreshSig = window.$RefreshSig$;
  window.$RefreshReg$ = (type, id) => {
    window.$RefreshRuntime$.register(type, "\"app/routes/auth.login/VerifyOtpForm.tsx\"" + id);
  }
  window.$RefreshSig$ = window.$RefreshRuntime$.createSignatureFunctionForTransform;
}
var _s = $RefreshSig$();
import * as __hmr__ from "remix:hmr";
if (import.meta) {
  import.meta.hot = __hmr__.createHotContext(
  //@ts-expect-error
  "app/routes/auth.login/VerifyOtpForm.tsx");
  import.meta.hot.lastModified = "1767756147000";
}
// REMIX HMR END

import { Collapse, IconButton } from '@mui/material';
import Alert from '~/components/Alert/Alert';
import { Close, EmailRounded, PhoneRounded } from '@mui/icons-material';
import { useEffect, useState } from 'react';
import { useNavigate, useSubmit } from '@remix-run/react';
import { LoginMessage } from './data';
export default function VerifyOtpForm({
  actionData
}) {
  _s();
  const [data] = useState(actionData?.data || undefined);
  const {
    mfaToken,
    maskedEmail,
    maskedPhone
  } = data;
  const navigate = useNavigate();
  const [mfaChannel, setMfaChannel] = useState(null);
  const [otp, setOtp] = useState(Array(6).fill(''));
  const [verifyingOtp, setVerifyingOtp] = useState(false);
  const [alertProps, setAlertProps] = useState({
    isShow: false,
    message: '',
    type: undefined
  });
  const [timer, setTimer] = useState(60);
  const [isResendDisabled, setIsResendDisabled] = useState(true);
  const [isPreventUnload, setIsPreventUnload] = useState(true);
  const submit = useSubmit();
  const onOtpChange = (index, value) => {
    if (value && !/^\d$/.test(value)) return;
    const newOtp = [...otp];
    newOtp[index] = value;
    setOtp(newOtp);
    if (value && index < 5) {
      const nextInput = document.getElementById(`otp-input-${index + 1}`);
      nextInput?.focus();
    }
  };
  const onOtpKeyDown = (index, e) => {
    if (e.key === 'Backspace' && !otp[index] && index > 0) {
      const prevInput = document.getElementById(`otp-input-${index - 1}`);
      prevInput?.focus();
    }
  };
  const onOtpPaste = e => {
    e.preventDefault();
    const pastedData = e.clipboardData.getData('text/plain').slice(0, 6);
    if (!/^\d+$/.test(pastedData)) return;
    const newOtp = [...otp];
    pastedData.split('').forEach((char, index) => {
      if (index < 6) {
        newOtp[index] = char;
      }
    });
    setOtp(newOtp);
    const nextEmptyIndex = newOtp.findIndex(val => !val);
    const focusIndex = nextEmptyIndex === -1 ? 5 : nextEmptyIndex;
    const focusInput = document.getElementById(`otp-input-${focusIndex}`);
    focusInput?.focus();
  };
  useEffect(() => {
    if (timer > 0) {
      const countdown = setTimeout(() => setTimer(timer - 1), 1000);
      return () => clearTimeout(countdown);
    } else {
      setIsResendDisabled(false);
    }
  }, [timer]);
  const onAlertHandler = () => {
    setAlertProps(prevState => {
      return {
        ...prevState,
        isShow: false,
        message: ''
      };
    });
  };
  const handleResend = async channel => {
    const formData = new FormData();
    formData.append('actionType', 'resend_otp');
    formData.append('mfaToken', mfaToken);
    formData.append('mfaChannel', channel);
    const request = await fetch('/auth/login?_data', {
      method: 'POST',
      body: formData
    });
    const response = await request.json();
    if (response?.status?.type === 'error' && response?.status?.message === LoginMessage.RESEND_OTP_EXPIRED) {
      handleBackToLogin();
      return;
    }
    setTimer(60);
    setIsResendDisabled(true);
    setOtp(Array(6).fill(''));
  };
  const formatTime = seconds => {
    const mins = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${mins}:${secs.toString().padStart(2, '0')}`;
  };
  const handleBackToLogin = () => {
    setIsPreventUnload(false);
    navigate('/auth/login', {
      replace: true
    });
  };
  const handleVerifyOtp = async e => {
    e.preventDefault();
    setVerifyingOtp(true);
    try {
      const formData = new FormData();
      formData.append('mfaToken', mfaToken);
      formData.append('otp', otpValue);
      formData.append('actionType', 'verify_otp');
      submit(formData, {
        method: 'post',
        action: '/auth/login'
      });
    } catch (error) {
      setVerifyingOtp(false);
      setAlertProps(prevState => {
        return {
          ...prevState,
          isShow: true,
          type: 'error',
          message: 'An error occurred while verifying the OTP code'
        };
      });
    }
  };
  const handleBeforeUnload = e => {
    if (isPreventUnload) {
      e.preventDefault();
      return '';
    }
  };
  const handleSelectMfaChannel = (e, channel) => {
    e.preventDefault();
    setMfaChannel(channel);
    handleResend(channel);
  };
  const {
    isShow,
    type
  } = alertProps;
  const otpValue = otp.join('');
  useEffect(() => {
    window.addEventListener('beforeunload', handleBeforeUnload);
    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload);
    };
  }, [isPreventUnload]);
  useEffect(() => {
    if (actionData?.status?.message === LoginMessage.VERIFY_OTP_INVALID) {
      setVerifyingOtp(false);
      setAlertProps(prevState => {
        return {
          ...prevState,
          isShow: true,
          type: 'error',
          message: LoginMessage.VERIFY_OTP_INVALID
        };
      });
    }
  }, [actionData]);
  const title = (() => {
    if (mfaChannel) {
      return 'Verify a Code';
    }
    return 'Get a code to sign in';
  })();
  const subtitle = (() => {
    if (mfaChannel === 'email') {
      return `Enter the 6-digit code sent to your email (${maskedEmail})`;
    }
    if (mfaChannel === 'phone') {
      return `Enter the 6-digit code sent to your phone (${maskedPhone})`;
    }
    return 'Please select a way to get a code';
  })();
  const alertMessage = (() => {
    if (isShow && type === 'error') {
      return 'Invalid OTP code. Please try again.';
    }
    return 'OTP code has been resent';
  })();
  return <div className="wrapper relative block min-h-[217px] w-[452px] bg-doctor p-[50px] rounded-[8px] [box-shadow:24px_24px_48px_5px_rgba(0,_0,_0,_0.05)]">
      <h5 className="header relative block text-umbra font-bold text-[32px] text-left mb-[12px]">
        {title}
      </h5>
      <h6 className="subheader relative block text-left text-[16px] text-trolleygrey mb-[30px] font-normal">
        {subtitle}
      </h6>

      <div className="mb-6">
        <Collapse in={alertProps.isShow}>
          <Alert variant="filled" severity={type} className="h-auto" action={<IconButton aria-label="close" color="inherit" size="small" onClick={onAlertHandler}>
                <Close className="!text-white" fontSize="inherit" />
              </IconButton>}>
            {alertMessage}
          </Alert>
        </Collapse>
      </div>

      {mfaChannel === null ? <div className="select-mfa-channel relative flex flex-col items-center mb-[24px] gap-[12px]">
          {maskedEmail && <button type="button" name="actionType" value="select_mfa_channel" onClick={e => handleSelectMfaChannel(e, 'email')} className="select-mfa-channel-item relative flex items-center w-full p-3 gap-3 border-[1px] border-solid border-bluelight rounded-[4px] text-[14px] font-normal text-black disabled:opacity-50 disabled:cursor-not-allowed">
              <EmailRounded className=" !text-black size-5" />
              <span className="font-semibold">{maskedEmail}</span>
            </button>}
          {maskedPhone && <button type="button" name="actionType" value="select_mfa_channel" onClick={e => handleSelectMfaChannel(e, 'phone')} className="select-mfa-channel-item relative flex items-center w-full p-3 gap-3 border-[1px] border-solid border-bluelight rounded-[4px] text-[14px] font-normal text-black disabled:opacity-50 disabled:cursor-not-allowed">
              <PhoneRounded className=" !text-black size-5" />
              <span className="font-semibold">{maskedPhone}</span>
            </button>}
          <button className="button-back relative flex items-center justify-center w-full px-0 py-2 bg-transparent border-none text-[14px] font-normal text-bluelight" type="button" onClick={handleBackToLogin} name="actionType" disabled={verifyingOtp} value="back_to_options">
            Back to Login
          </button>
        </div> : <form method="post" onSubmit={handleVerifyOtp}>
          <div className="otp-container relative flex justify-between gap-[8px] mb-[24px]">
            {otp.map((digit, index) => <input key={index} id={`otp-input-${index}`} type="text" maxLength={1} className="otp-input relative block w-[50px] h-[50px] text-center text-[24px] font-semibold rounded-[4px] border-primarylight border-[1px] border-[solid] focus:border-bluelight focus:border-[2px] focus:outline-none" value={digit} onChange={e => onOtpChange(index, e.target.value)} onKeyDown={e => onOtpKeyDown(index, e)} onPaste={index === 0 ? onOtpPaste : undefined} />)}
          </div>

          <div className="button-container relative flex flex-col gap-[12px]">
            <button className="button-verify relative flex items-center justify-center w-full px-0 py-[14px] bg-bluelight rounded-[4px] text-[14px] font-normal text-doctor disabled:opacity-50 disabled:cursor-not-allowed" type="submit" disabled={otpValue.length !== 6 || verifyingOtp}>
              {verifyingOtp ? 'Verifying...' : 'Verify'}
              <i className="button-icon bg-[url('/assets/images/login/sign-in.svg')] relative block [background-size:20px] w-[20px] h-[20px] bg-no-repeat ml-[10px]"></i>
            </button>

            <button className="button-back relative flex items-center justify-center w-full px-0 py-[14px] bg-transparent border-[1px] border-solid border-bluelight rounded-[4px] text-[14px] font-normal text-bluelight hover:bg-bluelight hover:text-doctor transition-colors" type="button" onClick={() => setMfaChannel(null)} name="actionType" disabled={verifyingOtp} value="back_to_options">
              Back to options
            </button>
          </div>

          <div className="resend-container relative flex flex-col items-center mt-[24px]">
            {isResendDisabled ? <p className="text-trolleygrey text-[14px]">
                Resend code in{' '}
                <span className="font-semibold text-umbra">
                  {formatTime(timer)}
                </span>
              </p> : <button type="button" name="actionType" value="resend_otp" onClick={() => handleResend(mfaChannel)} disabled={verifyingOtp} className="text-bluelight font-semibold text-[14px] hover:underline">
                Resend Code
              </button>}
          </div>
        </form>}
    </div>;
}
_s(VerifyOtpForm, "0N3OUECltRiGhmj73FFyTtnJS9Q=", false, function () {
  return [useNavigate, useSubmit];
});
_c = VerifyOtpForm;
var _c;
$RefreshReg$(_c, "VerifyOtpForm");

window.$RefreshReg$ = prevRefreshReg;
window.$RefreshSig$ = prevRefreshSig;